/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EstadoInventarioCriteriaDto } from '../models/estado-inventario-criteria-dto';
import { EstadoInventarioDto } from '../models/estado-inventario-dto';
import { EstadoInventarioFormDto } from '../models/estado-inventario-form-dto';
import { EstadoInventarioPageDto } from '../models/estado-inventario-page-dto';


/**
 * Estados Inventário Fontes Seladas
 */
@Injectable({
  providedIn: 'root',
})
export class EstadosInventarioService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getEstadosInventario
   */
  static readonly GetEstadosInventarioPath = '/estados-inventario';

  /**
   * Pesquisar estados inventário.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEstadosInventario()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstadosInventario$Response(params?: {
    criteria?: EstadoInventarioCriteriaDto;
  }): Observable<StrictHttpResponse<EstadoInventarioPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, EstadosInventarioService.GetEstadosInventarioPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EstadoInventarioPageDto>;
      })
    );
  }

  /**
   * Pesquisar estados inventário.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEstadosInventario$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstadosInventario(params?: {
    criteria?: EstadoInventarioCriteriaDto;
  }): Observable<EstadoInventarioPageDto> {

    return this.getEstadosInventario$Response(params).pipe(
      map((r: StrictHttpResponse<EstadoInventarioPageDto>) => r.body as EstadoInventarioPageDto)
    );
  }

  /**
   * Path part for operation createEstadoInventario
   */
  static readonly CreateEstadoInventarioPath = '/estados-inventario';

  /**
   * Criar Estados Inventario Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEstadoInventario()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEstadoInventario$Response(params?: {

    /**
     * apiRequest
     */
    body?: EstadoInventarioFormDto
  }): Observable<StrictHttpResponse<EstadoInventarioDto>> {

    const rb = new RequestBuilder(this.rootUrl, EstadosInventarioService.CreateEstadoInventarioPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EstadoInventarioDto>;
      })
    );
  }

  /**
   * Criar Estados Inventario Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createEstadoInventario$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEstadoInventario(params?: {

    /**
     * apiRequest
     */
    body?: EstadoInventarioFormDto
  }): Observable<EstadoInventarioDto> {

    return this.createEstadoInventario$Response(params).pipe(
      map((r: StrictHttpResponse<EstadoInventarioDto>) => r.body as EstadoInventarioDto)
    );
  }

  /**
   * Path part for operation getEstadoInventario
   */
  static readonly GetEstadoInventarioPath = '/estados-inventario/{id}';

  /**
   * Obter Estados Inventario.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEstadoInventario()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstadoInventario$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<EstadoInventarioDto>> {

    const rb = new RequestBuilder(this.rootUrl, EstadosInventarioService.GetEstadoInventarioPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EstadoInventarioDto>;
      })
    );
  }

  /**
   * Obter Estados Inventario.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEstadoInventario$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstadoInventario(params: {
    id: number;
  }): Observable<EstadoInventarioDto> {

    return this.getEstadoInventario$Response(params).pipe(
      map((r: StrictHttpResponse<EstadoInventarioDto>) => r.body as EstadoInventarioDto)
    );
  }

  /**
   * Path part for operation updateEstadoInventario
   */
  static readonly UpdateEstadoInventarioPath = '/estados-inventario/{id}';

  /**
   * Atualizar Estados Inventario.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEstadoInventario()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEstadoInventario$Response(params: {
    id: number;
    body?: EstadoInventarioFormDto
  }): Observable<StrictHttpResponse<EstadoInventarioDto>> {

    const rb = new RequestBuilder(this.rootUrl, EstadosInventarioService.UpdateEstadoInventarioPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EstadoInventarioDto>;
      })
    );
  }

  /**
   * Atualizar Estados Inventario.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateEstadoInventario$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEstadoInventario(params: {
    id: number;
    body?: EstadoInventarioFormDto
  }): Observable<EstadoInventarioDto> {

    return this.updateEstadoInventario$Response(params).pipe(
      map((r: StrictHttpResponse<EstadoInventarioDto>) => r.body as EstadoInventarioDto)
    );
  }

  /**
   * Path part for operation ativarEstadoInventario
   */
  static readonly AtivarEstadoInventarioPath = '/estados-inventario/{id}/ativar';

  /**
   * Ativar EstadosInventario.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarEstadoInventario()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarEstadoInventario$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<EstadoInventarioDto>> {

    const rb = new RequestBuilder(this.rootUrl, EstadosInventarioService.AtivarEstadoInventarioPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EstadoInventarioDto>;
      })
    );
  }

  /**
   * Ativar EstadosInventario.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarEstadoInventario$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarEstadoInventario(params: {
    id: number;
  }): Observable<EstadoInventarioDto> {

    return this.ativarEstadoInventario$Response(params).pipe(
      map((r: StrictHttpResponse<EstadoInventarioDto>) => r.body as EstadoInventarioDto)
    );
  }

  /**
   * Path part for operation desativarEstadoInventario
   */
  static readonly DesativarEstadoInventarioPath = '/estados-inventario/{id}/desativar';

  /**
   * Desativar EstadosInventario.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarEstadoInventario()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarEstadoInventario$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<EstadoInventarioDto>> {

    const rb = new RequestBuilder(this.rootUrl, EstadosInventarioService.DesativarEstadoInventarioPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EstadoInventarioDto>;
      })
    );
  }

  /**
   * Desativar EstadosInventario.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarEstadoInventario$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarEstadoInventario(params: {
    id: number;
  }): Observable<EstadoInventarioDto> {

    return this.desativarEstadoInventario$Response(params).pipe(
      map((r: StrictHttpResponse<EstadoInventarioDto>) => r.body as EstadoInventarioDto)
    );
  }

}
